/**
 * Created by zookeeper on 7/15/2016.
 */
var activity_param = {
    review_start:0,
    limit:6,
    activity_start:0,
    activity_loading:false,
    review_loading:false
};
var applyRules = {
    username: {
        identifier: 'username',
        rules: [
            {
                type: 'empty',
                prompt: "请输入用户名"
            }
        ]
    },
    email: {
        identifier: 'email',
        rules: [
            {
                type: 'email',
                prompt: "请输入合法的邮箱地址"
            }
        ]
    }
    ,
    work_institute: {
        identifier: 'work_institute',
        rules: [
            {
                type: 'empty',
                prompt: "请选择所属部门",
            }
        ]
    },
    phone: {
        identifier: 'phone',
        rules: [
            {
                type: 'regExp[\^[0-9]{11}$\]',
                prompt: "请输入11位手机号",
            }
        ]
    }


};
$(document).ready(function(){
    getActivitySlider(0,4);
    $('#apply-form').form({
        keyboardShortcuts:false,
        fields: applyRules,
        inline: true,
        on: 'submit'
    });
    /*
    事件代理
     */
    /*
    活动报名
     */
    $('#apply-form').on('click','.button.apply',function(event){
        var activity_id = $('#apply-form').data('activity_id');
        activityApply(activity_id);
    });

    /*
    往期回顾
     */
    $('#scienceActivity').on('click','.review-more',function(e){
        $(this).parents('.ui.card').find('.review-past-wrap')
            .transition('swing left');
    }).on('click','.review-back',function(e){
        $(this).parents('.ui.card').find('.review-past-wrap')
            .transition('swing left');
    }).on('click','.ui.card .extra .apply-btn',function(event){
        var activity_id = $(this).closest('.ui.card').data('id');
        showApplyForm(activity_id);
    }).on('click','.collect-btn',function(event){
        var activity_id = $(this).closest('.ui.card').data('id');
       // addCollect(activity_id);

    });
    $('.btn-more').on('click',function(event){
        var $btn = $(this);
        var type = $btn.data('type');
        if(type == 'review'){
            if(activity_param.review_loading){
                return false;
            }
            activity_param.review_loading = true;
            var promise = getActivityReview(activity_param.review_start,activity_param.limit);
            promise.done(function(data){
                var length = data.activities.length;
                if(length < activity_param.limit){
                    $btn.slideUp();
                }else{
                    activity_param.review_loading = false;
                }
            });
        }else{
            if(activity_param.activity_loading){
                return false;
            }
            activity_param.activity_loading = true;
            var promise = getScienceActivity(activity_param.activity_start,activity_param.limit);
            promise.done(function(data){
                var length = data.activities.length;
                if(length < activity_param.limit){
                    $btn.slideUp();
                }else{
                   // $btn.prop('disabled',false);
                    activity_param.activity_loading = false;
                }
            });


        }
    });

    var review_promise = getActivityReview(activity_param.review_start,activity_param.limit);
    review_promise.done(function(data){
        if(data.activities.length == activity_param.limit){
            $('.btn-more.review-more').show();

        }
    });
    var science_promise = getScienceActivity(activity_param.activity_start,activity_param.limit);
    science_promise.done(function(data){
        if(data.activities.length == activity_param.limit){
            $('.btn-more.science-more').show();

        }
    });

});
function getActivitySlider(start,limit){
     var promise = activitySlider(start,limit);
    promise.done(function(data){
        $('#slider').html(S['templates']['activity_slider'](data));
        $('#slider').nivoSlider({});

    });
}
function getScienceActivity(start,limit){
    var promise = scienceActivity(start,limit);
    promise.done(function(data){
        $('#scienceActivity').append(S['templates']['activity_card'](data));
        $('#scienceActivity.special.cards .image').dimmer({
            on: 'hover'
        });
        var length = data.activities.length;
        activity_param.activity_start = activity_param.activity_start + length;

    });
    return promise;

}
function getActivityReview(start,limit){
    var promise = activityReview(start,limit);
    promise.done(function(data){
        $('#activityReview').append(S['templates']['activity_report'](data));
        $('#activityReview.special.cards .image').dimmer({
            on: 'hover'
        });
        var length = data.activities.length;
        activity_param.review_start = activity_param.review_start + length;

    });
    return promise;

}
function showApplyForm(activity_id){
    if(!sessionStorage.getItem("user")){
        $('.login-modal').modal('show');
        return;
    }
    $('#apply-modal').data('activity_id',activity_id);
    $('#apply-modal').modal('show');
}
function activityApply(activity_id){
    var valid = $('#apply-form').form('is valid', applyRules);
    if(valid) {
        var username = $('#apply-form input[name=username]').val();
        var email = $('#apply-form input[name=email]').val();
        var work_institute = $('#apply-form input[name=work_institute]').val();
        var phone = $('#apply-form input[name=phone]').val();
        var promise = activityPost(username, email, work_institute, phone, activity_id);
        promise.done(function (data) {
            $('#apply-modal').modal('hide');

        });
    }

}
function addCollect(activity) {
    if (!sessionStorage.getItem("user")) {
        $('.login-modal').modal('show');
        return;
    }
    var promise = activityStar(activity);
    promise.done(function (data) {
        if (data.status != 0) {
            $('#warning').find('.content').text(data.message);
            $('#warning').modal('show');
        } else {
            $('#warning').find('.content').text("收藏成功");
            $('#warning').modal('show');

        }
    });
}


/*
fetch/post data,return promise for reuse
 */
function activitySlider(start,limit){
    return $.ajax({
        url: server_base + '/activity/get/type/top',
        data: {
            start: start,
            limit: limit
        },
        dataType: 'json'
    });
}
function scienceActivity(start,limit){
    return  $.ajax({
        url: server_base + '/activity/get/type/new_science',
        data: {
            start: start,
            limit: limit
        },
        dataType: 'json'
    });
}
function activityReview(start,limit){
    return $.ajax({
        url: server_base + '/activity/get/type/review',
        data: {
            start: start,
            limit: limit
        },
        dataType: 'json'
    });
}
function activityPost(username,email,phone,work_institute,activity){
    return $.ajax({
        url: server_base + '/activity/apply/id/' + activity,
        method: 'POST',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true,
        data: {
            username: username,
            email: email,
            phone: phone,
            institute: work_institute,
        }
    });

}
function activityStar(activity){
    return $.ajax({
        url: server_base + '/activity/star/' + activity,
        method:'POST',
        //xhrFields: {withCredentials: true},
        ////crossDomain: true,
    });
}